

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectCard', function () {
    return {
        template: _template2['default'],

        scope: {
            parentCallbacks: '=?',
            token: '=?',
            promotion: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.selectCardType = function (type) {
                    // card type is either 'cc' or 'plcc'
                    $scope.parentCallbacks.cardTypeSelected(type);
                };
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js
// module chunks = 0